"use client";

import React from "react";
import { Linkedin, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-background text-foreground py-16 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <img src="/img/maia_lafortezza_logo.png" alt="Maia Lafortezza Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Helping entrepreneurs and growth-stage companies build scalable, profitable, and well-structured businesses through strategic consulting and operational optimization.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-medium tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="38" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-medium tracking-tight">Contact</h3>
            <ul className="flex flex-col gap-4">
              <li data-index={0} className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-primary" />
                <span>123 Main St, Springfield</span>
              </li>
              <li data-index={1} className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 shrink-0 text-primary" />
                <Link to="tel:+15551234567" className="hover:text-primary transition-colors">
                  (555) 123-4567
                </Link>
              </li>
              <li data-index={2} className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 shrink-0 text-primary" />
                <Link to="mailto:info@maialafortezza.com" className="hover:text-primary transition-colors">
                  info@maialafortezza.com
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-base font-medium tracking-tight">Follow Us</h3>
            <div className="flex items-center gap-4">
              <Link to="https://linkedin.com" newTab className="flex items-center justify-center w-10 h-10 rounded-full bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300" aria-label="LinkedIn">
                <Linkedin className="w-4 h-4" />
              </Link>
              <Link to="https://instagram.com" newTab className="flex items-center justify-center w-10 h-10 rounded-full bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-border/60" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p className="text-[12px] font-sans text-muted-foreground">
            &copy; {currentYear} Maia Lafortezza. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="text-[12px] font-sans text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-[12px] font-sans text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}